<script>
  import solicitacaoReembolsoTerceiroServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';
  import tiposConta from '~js/tipos-conta';
  import tiposPix from '~js/tipos-pix';
  import ListaDespesas from './compartilhado/FormListaDespesas.vue';
  
  export default {
    components: { Cabecalho, Barcode, ListaDespesas },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        tiposConta: tiposConta,
        tiposPix: tiposPix,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoReembolsoTerceiroServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      tipoConta(id) {
        return this.tiposConta.find(t => {
          return t.id === id;
        });
      },
      tipoPix(id) {
        return this.tiposPix.find(t => {
          return t.id === id;
        });
      },
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Reembolso Terceiro - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-reembolso-terceiro';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">
              <cabecalho :titulo="'Solicitação de Reembolso Terceiro'"></cabecalho>

              <h3 class="m-t-none m-b">Dados da solicitação</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-8">
                  <dt>Projeto</dt>
                  <dd>{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Tipo de projeto</dt>
                  <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Período de vigência</dt>
                  <dd>{{ periodoDeVigencia }}</dd>
                </dl>

                <dl class="col-xs-6">
                  <dt>Nr. processo</dt>
                  <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Número</dt>
                  <dd>{{ solicitacao.idSolicitacaoReembolsoTerceiro || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Data da solicitação</dt>
                  <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Coordenador do projeto</dt>
                  <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                  <dt>Data de liberação do coordenador</dt>
                  <dd>{{ dataLiberacaoCoordenador }}</dd>
                </dl>
                <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                  <dt>Liberado por</dt>
                  <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                </dl>
                <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                  <dt>Nº protocolo</dt>
                  <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                </dl>

                <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                  <dt>Código de barras protocolo</dt>
                  <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                </dl>
              </div>

              <div class="row" v-if="configuracao.selecaoDeContaWeb">
                <dl class="col-xs-12">
                  <dt>Conta</dt>
                  <dd>{{ solicitacao.contaProjeto ? solicitacao.contaProjeto.nome : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>Justificativa</dt>
                  <dd>{{ solicitacao.observacao ? solicitacao.observacao : '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados cadastrais</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Nome</dt>
                  <dd>{{ solicitacao.nomeRequerinte || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>CPF</dt>
                  <dd>{{ solicitacao.cpf || '---' }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Data de nascimento</dt>
                  <dd>{{ solicitacao.dataNascimento | formatarNumeroEmData('---') }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Endereço</dt>
                  <dd>{{ solicitacao.endereco || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Número</dt>
                  <dd>{{ solicitacao.numero || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Complemento</dt>
                  <dd>{{ solicitacao.complemento || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Bairro</dt>
                  <dd>{{ solicitacao.bairro || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Cidade</dt>
                  <dd>{{ solicitacao.cidade || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Estado</dt>
                  <dd>{{ solicitacao.uf || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Telefone</dt>
                  <dd>{{ solicitacao.telefone || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Celular</dt>
                  <dd>{{ solicitacao.celular || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>E-mail do beneficiário</dt>
                  <dd>{{ solicitacao.email || '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados bancários</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row" v-if="solicitacao.tipoConta != 4">
                <dl class="col-xs-3">
                  <dt>Banco</dt>
                  <dd>{{ solicitacao.banco || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Agência</dt>
                  <dd>{{ solicitacao.agencia || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Conta</dt>
                  <dd>{{ solicitacao.conta || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Tipo de conta</dt>
                  <dd>{{ tipoConta(solicitacao.tipoConta).nome }}</dd>
                </dl>
              </div>

              <div class="row" v-if="solicitacao.tipoConta == 4">
                <dl class="col-xs-3">
                  <dt>Tipo pix</dt>
                  <dd>{{ tipoPix(solicitacao.tipoPix).nome }}</dd>
                </dl>

                <dl class="col-xs-9">
                  <dt>Chave PIX</dt>
                  <dd>{{ solicitacao.chavePix || '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Despesas</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row" v-if="solicitacao.compraDireta">
                <dl class="col-xs-12">
                  <dt>Este pagamento é uma compra direta</dt>
                </dl>
              </div>

              <div>
                <lista-despesas :despesas="solicitacao.despesas"
                                :relatorio="true"
                                :utilizarMetaEtapaProjeto="solicitacao.projeto.utilizarMetaEtapaProjeto"
                                :exibirRubricaSubrubricaSolicitacaoWeb="configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.projeto.utilizarRubricaSubrubricaWeb">
                </lista-despesas>
              </div>

              <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solReembolsoTerceiroMsgConfirmacao"></div>

              <div class="row" v-if="this.configuracao.solReembolsoTerceiroMsgConfirmacao">
                <div class="col-md-12">
                  <p><i>{{this.configuracao.solReembolsoTerceiroMsgConfirmacao}}</i></p>
                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-terceiro/componentes/SolicitacaoReembolsoTerceiroRelatorio.vue